module.exports = __webpack_public_path__ + "img/Yellow.d1e722aa.png";